<template>
    <div v-if="isLoaded">
        <div class="content-body" v-bind:class="{ fullscreen_expand: isFullscreen }">
            <div class="row match-height">
                <div class="col-xl-12 col-lg-12">
                    <div class="card" style="">
                        <div class="card-header">
                            <h4 class="card-title">Cliente Conexão</h4>
                            <a class="heading-elements-toggle"><i class="fa fa-ellipsis-v font-medium-3"></i></a>
                            <div class="heading-elements">
                                <ul class="list-inline mb-0">
                                    <li><a @click="onCreate()" v-b-tooltip title="Cadastrar" v-if="getPermissionFw('pessoaconexao.store')"><i class="fa fa-plus"></i></a></li>
                                    <li><a @click="onFilterReset()" v-b-tooltip title="Atualizar listagem"><i class="ft-rotate-cw"></i></a></li>
                                    <li><a @click="expandFullscreenFw()" v-b-tooltip title="Expande a tela" v-if="!isFullscreen"><i class="ft-maximize"></i></a></li>
                                    <li><a @click="expandFullscreenFw()" v-b-tooltip title="Minimiza a tela" v-if="isFullscreen"><i class="ft-minimize"></i></a></li>
                                    <li><a @click="onFilterShowHideFw()" v-b-tooltip.hover.left="'Filtros'"><i class="fa fa-filter"></i></a></li>
                                    <li><a @click="onActivateDesactivate(1, null, false)" v-b-tooltip title="Ativar Registros"  v-if="getPermissionFw('pessoaconexao.status')"><i class="fa fa-thumbs-o-up"></i></a></li>
                                    <li><a @click="onActivateDesactivate(2, null, false)" v-b-tooltip title="Inutilizar Registros"  v-if="getPermissionFw('pessoaconexao.status')"><i class="fa fa-thumbs-o-down"></i></a></li>
                                </ul>
                            </div>
                        </div>
                    <div class="card-content">
                        <div class="table-responsive">
                            <div v-if="vuetableFilterRow">
                                <vuetable-filterbar :tabela="'pessoa'">
                                </vuetable-filterbar>
                            </div>
                        <div class="loadingDataPosition">
                            <div class="loadingData" v-if="loadingData"><div class="loadingDataSpinner"><spinner v-if="loadingData" text-fg-color="#ffffff" message="Carregando..."></spinner></div></div>
                            <vuetable ref="vuetable"
                                    api-url="/api/pessoaconexao"
                                    :fields="fields"
                                    :css="css"
                                    :append-params="moreParams"
                                    track-by="pessoa_id"
                                    pagination-path=""
                                    @vuetable:load-error="onError"
                                    @vuetable:pagination-data="onPaginationData"
                                    @vuetable:cell-clicked="onDetail"
                                    detail-row-component="pessoaconexao-detalhes"
                                    @vuetable:loaded="onLoaded">
                                  <template slot="status" slot-scope="props">
                                      <span class="badge badge-success" v-if="props.rowData.status.valor==1">{{ props.rowData.status.descr }}</span>
                                      <span class="badge badge-danger" v-if="props.rowData.status.valor==2">{{ props.rowData.status.descr }}</span>
                                  </template>

                                  <template slot="identificacao" slot-scope="props">
                                      <span v-if="props.rowData.pessoa_juridica!==null">{{ onFormataCnpj(props.rowData.pessoa_juridica.cnpj_base,props.rowData.pessoa_juridica.cnpj_filial,props.rowData.pessoa_juridica.cnpj_digito)}}</span>
                                      <span v-if="props.rowData.pessoa_exterior!==null">{{ props.rowData.pessoa_exterior.cuit }}</span>
                                      <span v-if="props.rowData.pessoa_fisica!==null">{{ props.rowData.pessoa_fisica.cpf }}</span>
                                  </template>

                                  <template slot="identificacaonome" slot-scope="props">
                                      <span v-if="props.rowData.pessoa_juridica!==null">{{ props.rowData.pessoa_juridica.razao_social }}</span>
                                      <span v-if="props.rowData.pessoa_exterior!==null">{{ props.rowData.pessoa_exterior.nome }}</span>
                                      <span v-if="props.rowData.pessoa_fisica!==null">{{ props.rowData.pessoa_fisica.nome }}</span>
                                  </template>

                                  <template slot="tp_pessoa" slot-scope="props">
                                      <span class="badge badge-success" v-if="props.rowData.liv_tipo_pessoa.valor==1">{{ props.rowData.liv_tipo_pessoa.descr }}</span>
                                      <span class="badge badge-danger" v-if="props.rowData.liv_tipo_pessoa.valor==2">{{ props.rowData.liv_tipo_pessoa.descr }}</span>
                                      <span class="badge badge-info" v-if="props.rowData.liv_tipo_pessoa.valor==3">{{ props.rowData.liv_tipo_pessoa.descr }}</span>
                                  </template>

                                  <template slot="status" slot-scope="props">
                                      <span class="badge badge-success" v-if="props.rowData.status.valor==1">{{ props.rowData.status.descr }}</span>
                                      <span class="badge badge-danger" v-if="props.rowData.status.valor==2">{{ props.rowData.status.descr }}</span>
                                  </template>
                                  <template slot="actions" slot-scope="props">
                                    <div class="custom-actions">
                                        <a @click="onDetail(props.rowData, null, null)" v-b-tooltip title="Ver detalhes"><i class="fa fa-plus"></i></a>
                                      </button>
                                    </div>
                                  </template>
                            </vuetable>
                        </div>
                    <div>
                        <div class='col-md-12'>
                            <div class="pull-left pagination-detail">
                                <vuetable-pagination-info ref="paginationInfo"
                                                          :css="css.pagination"
                                                          info-class="pull-left"
                                ></vuetable-pagination-info>
                            </div>
                            <div class="pull-right m-a-0">
                                <vuetable-pagination ref="pagination"
                                                     :css="css.pagination"
                                                     @vuetable-pagination:change-page="onChangePage"
                                ></vuetable-pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<PessoaConexaoSelectForm ref="pessoaconexaoselectform" :metodo="onFilterReset"></PessoaConexaoSelectForm>

              </div>
          </div>
</template>
<script>
import { formatCNPJFromParts } from "../utils";

import Vuetable from '../components/Vuetable'
import VuetablePagination from '../components/VuetablePagination'
import VuetablePaginationInfo from '../components/VuetablePaginationInfo'
import PessoaFilterBar from './PessoaFilterBar'
import PessoaConexaoDetalhes from './PessoaConexaoDetalhes'
import PessoaConexaoSelectForm from './PessoaConexaoSelectForm'

Vue.component('pessoaconexao-detalhes', PessoaConexaoDetalhes);

export default {
components: {
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo,
    PessoaConexaoSelectForm,
    'vuetable-filterbar': PessoaFilterBar
},
data () {
    return {
      dataExport: [],
      modal_titulo: '',
      modal_botao: '',
      modal_acao: '',
      loading: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      form: new Form({ cd: '',
                       descr: '',
                       pessoa_id: '',
                       status: []
                   }),
     helpForm: new Form({recordCollection: [], status: ''}),
    fields: [{
        name: '__checkbox',
        titleClass: 'center aligned',
        dataClass: 'center aligned'
    },
    {
        name: 'cd',
        title: 'Código',
        sortField: 'cd'
    },
    {
        name: '__slot:tp_pessoa',
        title: 'Tipo',
        sortField: 'tp_pessoa'
    },
    {
        name: '__slot:identificacao',
        title: 'CNPJ/CPF',
        sortField: 'cnpj'
    },
    {
        name: '__slot:identificacaonome',
        title: 'Razão Social/Nome',
        sortField: 'cnpj'
    },
    {
        name: '__slot:status',
        title: 'Status',
        sortField: 'status'
    },
    {
        name: '__slot:actions',
        title: 'Ações',
        titleClass: 'center aligned',
        dataClass: 'center aligned'
    }
  ],
  css: {
      loadingClass: 'loading',
      ascendingIcon: 'glyphicon glyphicon-chevron-up',
      descendingIcon: 'glyphicon glyphicon-chevron-down',
      handleIcon: 'glyphicon glyphicon-menu-hamburger',
  },
  moreParams: {}
   }
},
mounted() {
    this.$events.$on('filter-set', eventData => this.onFilterSet(eventData));
    this.$events.$on('filter-reset', e => this.onFilterReset());
  },
methods: {
    onDetail(data, field, event) {
        this.$refs.vuetable.toggleDetailRow(data.pessoa_id);
    },
    onPaginationData (paginationData) {
      this.$refs.pagination.setPaginationData(paginationData)
      this.$refs.paginationInfo.setPaginationData(paginationData)
    },
    onChangePage (page) {
      this.$refs.vuetable.changePage(page)
    },
    onFilterSet (data_filter) {
        this.loadingData = true;
        this.moreParams = {
            'cd': data_filter.cd,
            'cnpj': data_filter.cnpj,
            'nome_fantasia': data_filter.nome_fantasia,
            'inscricao_estadual': data_filter.inscricao_estadual,
            'status': data_filter.status.value,
            'fornecedor': data_filter.fornecedor.value,
            'municipio': data_filter.municipio.value

        }
        Vue.nextTick( () => {this.$refs.vuetable.reload(); })
    },
    onFilterReset () {
        this.loadingData = true;
        this.moreParams = {}
        Vue.nextTick( () => this.$refs.vuetable.refresh())
    },
    onLoaded: function () {
        this.dataExport = this.$refs.vuetable.tableData;
        this.loadingData = false;
        this.$store.commit('setVuetableFilterButton', false);
    },
    onCreate ()
    {
      this.$refs.pessoaconexaoselectform.onCreate();
    },
    onActivateDesactivate(action, data, tipo)
    {
        // Tipo = true = Checkbox
        this.helpForm.status = action;
        if(tipo)
        {

            this.helpForm.recordCollection = [];
            this.helpForm.recordCollection.push(data.pessoa_id );
        }
        else
        {
            this.helpForm.recordCollection = [];
            this.$refs.vuetable.selectedTo.forEach((obj)=>{
                this.helpForm.recordCollection.push(obj)
            });
        }
        this.$refs.pessoaform.onActivateDesactivate(this.helpForm);
    },
        onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
      return formatCNPJFromParts(cnpj_base, cnpj_filial, cnpj_digito);
    },

    onError(response) {
        new ReturnApi(response.response, this, true, true, false);
    },
},
computed: {
    vuetableFilterRow: {
      get () {
        return this.$store.state.vuetable.filterRow;
      },
    },
    isLoaded: {
        get() {
            return this.$store.getters.isloaded;
        }
    },
    isFullscreen: {
        get() {
            return this.$store.getters.is_full_screen;
        }
    }
}
}
</script>